import { createQuery } from './core';
// PUBLIC API
export const getPaginatedUsers = createQuery('operations/get-paginated-users', ['User']);
// PUBLIC API
export const getUserById = createQuery('operations/get-user-by-id', ['User', 'LocationMembership', 'Location']);
// PUBLIC API
export const getMyProfile = createQuery('operations/get-my-profile', ['User']);
// PUBLIC API
export const getOnboardingStatus = createQuery('operations/get-onboarding-status', ['GlobalConfig', 'Location', 'User']);
// PUBLIC API
export const getGptResponses = createQuery('operations/get-gpt-responses', ['User', 'GptResponse']);
// PUBLIC API
export const getAllTasksByUser = createQuery('operations/get-all-tasks-by-user', ['Task']);
// PUBLIC API
export const getCustomerPortalUrl = createQuery('operations/get-customer-portal-url', ['User']);
// PUBLIC API
export const getAllFilesByUser = createQuery('operations/get-all-files-by-user', ['User', 'File']);
// PUBLIC API
export const getDownloadFileSignedURL = createQuery('operations/get-download-file-signed-url', ['User', 'File']);
// PUBLIC API
export const getDailyStats = createQuery('operations/get-daily-stats', ['User', 'DailyStats']);
// PUBLIC API
export const getAuthDomainConfig = createQuery('operations/get-auth-domain-config', ['AuthDomainConfig']);
// PUBLIC API
export const getAuthDomainRules = createQuery('operations/get-auth-domain-rules', ['AuthDomainRule']);
// PUBLIC API
export const getGeoBlockConfig = createQuery('operations/get-geo-block-config', ['GeoBlockConfig']);
// PUBLIC API
export const getGeoBlockRules = createQuery('operations/get-geo-block-rules', ['GeoBlockRule']);
// PUBLIC API
export const getLocations = createQuery('operations/get-locations', ['Location', 'LocationMembership', 'LocationTypeDefinition']);
// PUBLIC API
export const getLocationBySlug = createQuery('operations/get-location-by-slug', ['Location', 'LocationMembership', 'LocationTypeDefinition']);
// PUBLIC API
export const getUserMembership = createQuery('operations/get-user-membership', ['LocationMembership']);
// PUBLIC API
export const getPendingAccessRequests = createQuery('operations/get-pending-access-requests', ['MembershipAccessRequest', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getMyAccessRequest = createQuery('operations/get-my-access-request', ['MembershipAccessRequest']);
// PUBLIC API
export const getBmEligibleMembers = createQuery('operations/get-bm-eligible-members', ['LocationMembership', 'User']);
// PUBLIC API
export const getBuildingServiceRequests = createQuery('operations/get-building-service-requests', ['Content', 'LocationMembership', 'User']);
// PUBLIC API
export const getMyPlatformBuildings = createQuery('operations/get-my-platform-buildings', ['User']);
// PUBLIC API
export const getInviteCodes = createQuery('operations/get-invite-codes', ['InviteCode', 'LocationMembership']);
// PUBLIC API
export const getAllLocations = createQuery('operations/get-all-locations', ['Location', 'LocationTypeDefinition']);
// PUBLIC API
export const getLocationById = createQuery('operations/get-location-by-id', ['Location', 'LocationTypeDefinition']);
// PUBLIC API
export const getLocationWithChildren = createQuery('operations/get-location-with-children', ['Location']);
// PUBLIC API
export const getHubLocations = createQuery('operations/get-hub-locations', ['Location']);
// PUBLIC API
export const getLocationEntries = createQuery('operations/get-location-entries', ['Location', 'Content', 'Event', 'LocationMembership', 'User']);
// PUBLIC API
export const getAllLocationTypes = createQuery('operations/get-all-location-types', ['LocationTypeDefinition']);
// PUBLIC API
export const getLocationTypeById = createQuery('operations/get-location-type-by-id', ['LocationTypeDefinition']);
// PUBLIC API
export const getLocationTypeBySlug = createQuery('operations/get-location-type-by-slug', ['LocationTypeDefinition']);
// PUBLIC API
export const getLocationTypesForDropdown = createQuery('operations/get-location-types-for-dropdown', ['LocationTypeDefinition']);
// PUBLIC API
export const getLocationSectionConfig = createQuery('operations/get-location-section-config', ['Location', 'LocationTypeDefinition', 'LocationSectionOverride']);
// PUBLIC API
export const getVisibleSections = createQuery('operations/get-visible-sections', ['PlatformSectionVisibility', 'Location', 'LocationTypeDefinition', 'LocationSectionOverride']);
// PUBLIC API
export const getPlatformSectionVisibility = createQuery('operations/get-platform-section-visibility', ['PlatformSectionVisibility']);
// PUBLIC API
export const getVisibleOptionalFields = createQuery('operations/get-visible-optional-fields', ['PlatformOptionalFieldVisibility']);
// PUBLIC API
export const getPlatformOptionalFieldVisibility = createQuery('operations/get-platform-optional-field-visibility', ['PlatformOptionalFieldVisibility']);
// PUBLIC API
export const getLocationContent = createQuery('operations/get-location-content', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const getEvents = createQuery('operations/get-events', ['Event', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getEventById = createQuery('operations/get-event-by-id', ['Event', 'Location', 'User', 'LocationMembership', 'EventAttendee']);
// PUBLIC API
export const getLocationEvents = createQuery('operations/get-location-events', ['Event', 'LocationMembership', 'User']);
// PUBLIC API
export const getTenants = createQuery('operations/get-tenants', ['Tenant', 'Location']);
// PUBLIC API
export const getTenantById = createQuery('operations/get-tenant-by-id', ['Tenant', 'Location']);
// PUBLIC API
export const getNotices = createQuery('operations/get-notices', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getLocationNotices = createQuery('operations/get-location-notices', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const getNoticeById = createQuery('operations/get-notice-by-id', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getFacilities = createQuery('operations/get-facilities', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getFacilityById = createQuery('operations/get-facility-by-id', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getBuySells = createQuery('operations/get-buy-sells', ['Content', 'Location', 'User']);
// PUBLIC API
export const getBuySellById = createQuery('operations/get-buy-sell-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getTextbooks = createQuery('operations/get-textbooks', ['Content', 'Location', 'User']);
// PUBLIC API
export const getTextbookById = createQuery('operations/get-textbook-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getAccommodation = createQuery('operations/get-accommodation', ['Content', 'Location', 'User']);
// PUBLIC API
export const getAccommodationById = createQuery('operations/get-accommodation-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getRequestOffers = createQuery('operations/get-request-offers', ['Content', 'Location', 'User']);
// PUBLIC API
export const getRequestOfferById = createQuery('operations/get-request-offer-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getCarpools = createQuery('operations/get-carpools', ['Content', 'Location', 'User']);
// PUBLIC API
export const getCarpoolById = createQuery('operations/get-carpool-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getFoodCourtItems = createQuery('operations/get-food-court-items', ['Content', 'Location', 'User']);
// PUBLIC API
export const getFoodCourtItemById = createQuery('operations/get-food-court-item-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getLostFoundItems = createQuery('operations/get-lost-found-items', ['Content', 'Location', 'User']);
// PUBLIC API
export const getLostFoundItemById = createQuery('operations/get-lost-found-item-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getCommunityItems = createQuery('operations/get-community-items', ['Content', 'Location', 'User']);
// PUBLIC API
export const getCommunityItemById = createQuery('operations/get-community-item-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getRetailStores = createQuery('operations/get-retail-stores', ['Content', 'Location', 'User']);
// PUBLIC API
export const getRetailStoreById = createQuery('operations/get-retail-store-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getServices = createQuery('operations/get-services', ['Content', 'Location', 'User']);
// PUBLIC API
export const getServiceById = createQuery('operations/get-service-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getJobs = createQuery('operations/get-jobs', ['Content', 'Location', 'User']);
// PUBLIC API
export const getJobById = createQuery('operations/get-job-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getUpkeepRequests = createQuery('operations/get-upkeep-requests', ['Content', 'LocationMembership']);
// PUBLIC API
export const getBuildingDocuments = createQuery('operations/get-building-documents', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const globalSearch = createQuery('operations/global-search', ['Content', 'Event', 'Tenant', 'Location', 'LocationMembership']);
// PUBLIC API
export const getUserPermissions = createQuery('operations/get-user-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getPendingApprovals = createQuery('operations/get-pending-approvals', ['ApprovalRequest', 'Content', 'User', 'LocationMembership']);
// PUBLIC API
export const getUsersWithPermissions = createQuery('operations/get-users-with-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getMyPermissions = createQuery('operations/get-my-permissions', ['LocationPermission', 'User', 'Location', 'LocationMembership']);
// PUBLIC API
export const getLocationAdminsAndManagers = createQuery('operations/get-location-admins-and-managers', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getAllLocationsForPermissions = createQuery('operations/get-all-locations-for-permissions', ['Location', 'LocationPermission']);
// PUBLIC API
export const getApprovalHistory = createQuery('operations/get-approval-history', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const getApprovalStats = createQuery('operations/get-approval-stats', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const getNotifications = createQuery('operations/get-notifications', ['Notification', 'User', 'Location']);
// PUBLIC API
export const getMyContentSubscriptions = createQuery('operations/get-my-content-subscriptions', ['ContentSubscription', 'Content']);
// PUBLIC API
export const getUnreadNotificationCount = createQuery('operations/get-unread-notification-count', ['Notification', 'User']);
// PUBLIC API
export const getRecycleBinEntries = createQuery('operations/get-recycle-bin-entries', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getRecycleBinEntry = createQuery('operations/get-recycle-bin-entry', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getRecycleBinStats = createQuery('operations/get-recycle-bin-stats', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getEntriesScheduledForDeletion = createQuery('operations/get-entries-scheduled-for-deletion', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getAllReports = createQuery('operations/get-all-reports', ['Report', 'User', 'Location', 'Content']);
// PUBLIC API
export const getAllFeedbacks = createQuery('operations/get-all-feedbacks', ['Feedback', 'User', 'Location']);
// PUBLIC API
export const getGlobalConfig = createQuery('operations/get-global-config', ['GlobalConfig']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map